import { StorageFindDto, type StorageFindInterface } from '@zaoblako/shared/modules/storage/dtos/storage-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';

import * as yup from 'yup';

/** File storage bucket response body */
export interface BucketFindInterface {
  /** Unique identifier */
  id: number;
  /** Display name */
  name: string;
  /** Base path */
  path: string;
  /** Related storage data */
  storage: StorageFindInterface;
}

/** File storage bucket response body DTO schema */
export const BucketFindDto = SerdeDtoClass.create<BucketFindInterface>('storage/bucket-find.dto', {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  path: {
    label: 'Путь',
    serializer: yup.string(),
  },
  storage: {
    optional: true,
    label: 'Хранилище',
    nested: StorageFindDto,
    serializer: (_, nested) => nested,
  },
});
